<template>
  <div style="padding-bottom: 100px;">
    <div class="h5footer visible-xs-block">
      <div class="ub">
        <div>{{ `公司名称：${info.name}` }}</div>
        <div>浙ICP备11026113号</div>
      </div>

      <div class="ub">
        <div>浙公网安备33010602006438号</div>
        <div>{{ `服务热线：${info.tel}` }}</div>
      </div>

      <p>备案信息：增值电信业务经营许可证浙B2-20180376号</p>
    </div>
  </div>
</template>

<script>
import { hostToBusinessInfo } from '@/utils'
export default {
  data() {
    return {}
  },
  computed: {
    info() {
      return hostToBusinessInfo()
    },
  },
}
</script>
>

<style lang="less" scoped>
.h5footer {
  background: #eee;
  padding: 15px 0;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  color: #989898;
  line-height: 20px;
  text-align: center;

  .ub {
    display: flex;
    justify-content: space-around;
  }
}
</style>
